const LearningCourseSyncHistoryPolicy = {
  learningCourseSyncHistory: {
    keyFields: false,
  },
  LearningCourseSyncHistoryItemChanges: {
    keyFields: false,
  },
  LearningCourseEntitySyncHistory: {
    keyFields: false,
  },
};

export default LearningCourseSyncHistoryPolicy;
